import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

// Labels affiches (cf. AccumulatedSummaryPage.jsx) -> valeurs attendues cote backend.
const FILTER_MAP = { All: 'All', Group: 'Group', Supervisor: 'Supervisor', Bank: 'Bank' };
const DOCUMENT_TYPE_MAP = {
  '': '', Online: 'online', Local: 'local',
  'Local On Time': 'local_on_time', 'Local Overtime': 'local_overtime',
};
const DISPLAY_MODE_MAP = {
  Global: 'global', Bank: 'bank', Supervisor: 'supervisor',
  Group: 'group', Lottery: 'lottery', Date: 'date',
};
const ORDER_BY_MAP = { Code: 'code', Name: 'name' };

export const fetchAccumulatedSummary = ({
  filter, scope, dateFrom, dateTo, lotteryFrom, lotteryUp, documentType, displayMode, orderBy,
}) =>
  apiRequest(`/tickets/accumulated-summary/${toQuery({
    filter: FILTER_MAP[filter] || 'All',
    scope,
    date_from: dateFrom,
    date_to: dateTo,
    tirage_from: lotteryFrom,
    tirage_up: lotteryUp,
    document_type: DOCUMENT_TYPE_MAP[documentType] || '',
    display_mode: DISPLAY_MODE_MAP[displayMode] || 'global',
    order_by: ORDER_BY_MAP[orderBy] || 'code',
  })}`);
